import { InfractionType } from "./infractionType";
import { Address } from "./address";
import { Vehicle } from "./vehicle";
import { Regulator } from "./regulator";
import { InfractionState } from "./infractionState";
import { InfractionDocument } from "./infractionDocument";

export class Infraction {
    public id: string;
    public tempId: string;
    public actNumber: string;
    public infractionType: InfractionType = new InfractionType();

    public creationDate: string;
    public creationDateSince: string;
    public creationDateUntil: string;
    public withSendMail: boolean;

    public vehicle: Vehicle = new Vehicle();
    public infractionDate: string;
    public infractionAmount: number;
    public address: Address = new Address(null);
    public regulator: Regulator;
    public batch: string;
    public state: InfractionState;
    public amountPaid: number;
    public paymentDate: string;
    public comments: string = '';
    public act: InfractionDocument;
    public actPayReceipt: InfractionDocument;
    public discharge: InfractionDocument;
    public sent: boolean = false;
    public sendingMail: boolean = false;
    public honorario: number;
    public mountTotal: number;
    public hasBankGalicia: boolean = false;

    constructor(other?: Infraction) {
        if (other) {
            this.id = other.id;
            this.tempId = other.tempId;
            this.actNumber = other.actNumber;
            this.infractionType = new InfractionType(other.infractionType);

            this.creationDate = other.creationDate;
            this.creationDateSince = other.creationDateSince;
            this.creationDateSince = other.creationDateUntil;
            this.withSendMail = other.withSendMail;

            this.vehicle = new Vehicle(other.vehicle);

            if (this.vehicle && this.vehicle.contract) {
                if (this.vehicle.contract.bank.name === "BANCO GALICIA") {
                    this.hasBankGalicia = true;
                }
            }

            this.infractionDate = other.infractionDate;
            this.infractionAmount = other.infractionAmount;
            this.address = new Address(other.address);
            this.regulator = new Regulator(other.regulator);
            this.batch = other.batch;
            this.state = new InfractionState(other.state.id, other.state.description);
            this.amountPaid = other.amountPaid;
            this.paymentDate = other.paymentDate;
            this.comments = other.comments;
            this.act = new InfractionDocument(other.act);
            this.actPayReceipt = new InfractionDocument(other.actPayReceipt);
            this.discharge = new InfractionDocument(other.discharge);
            this.sent = other.sent;
            this.sendingMail = other.sendingMail;
            this.honorario = other.honorario;
            this.mountTotal = other.mountTotal;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/infraction.ts
 **/